﻿import $ from 'jquery';
import Storage from "../utilities/storage";
import ElementPosition from "../utilities/elementposition";

var $globalContainer: JQuery;

export class Alert {
  public static get AlertStorageKey(): string { return "Rustig.Alert"; }
  public static flashSaveSuccessful() {
    this.flash('Save Successful!');
  }
  public static flash(message: string, $container?: JQuery) {
    if (!message)
      return;

    let hasCustomContainer = $container && $container.length > 0;

    // build container if needed
    if (!$globalContainer) {
      $globalContainer = $('<div>').attr('id', 'alertGlobal');
      $(document.body).append($globalContainer);
    }

    // create message
    $globalContainer.hide();
    $globalContainer.children().remove();
    let $messageContainer = $('<div>').addClass('alert alert-success').text(message);
    $globalContainer.append($messageContainer);

    if (hasCustomContainer) {
      let position = $container.offset();
      $globalContainer.css(<any>position);
    }
    else {
      new ElementPosition($globalContainer).setPositionCenterScreen();
    }

    //show and fade
    $globalContainer.show().delay(2000).fadeOut('slow');
  }
}

$(function () {
  var alertMessage = $('[data-alert]').data('alert');
  if (alertMessage)
    Storage.set(Alert.AlertStorageKey, alertMessage);

  var message = Storage.get(Alert.AlertStorageKey);
  if (message) {
    Storage.remove(Alert.AlertStorageKey);
    Alert.flash(message);
  }
});

export default Alert;